import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { PublicProductAPI } from '../../../../services/PublicProductAPI';
import Carousell from '../carousell'; 
import PublicProductCard from '../../../pages/products/Card/ProductCard';
import styles from '../features/FeaturedProducts.module.css'; // Reutilizando os estilos de skeleton

const ProductsCarousell = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    const fetchProducts = async () => {
      try {
        const data = await PublicProductAPI.list_products({ signal: controller.signal });
        const activeProducts = data.filter(p => p.is_active !== false);
        setProducts(activeProducts.slice(0, 6));
      } catch (e) {
        if (e.name === 'AbortError') return;
        console.error('Erro ao buscar produtos:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
    return () => controller.abort();
  }, []);

  if (loading) {
    return (
      <Carousell title="EQUIPAMENTOS DE ELITE" subtitle="SUPRIMENTOS">
        {[...Array(4)].map((_, i) => (
          <div key={i} className={styles.skeletonCard} />
        ))}
      </Carousell>
    );
  }

  if (products.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
    >
      <Carousell title="EQUIPAMENTOS DE ELITE" subtitle="SUPRIMENTOS">
        {products.map((item) => (
          <PublicProductCard key={item.id} product={item} />
        ))}
      </Carousell>
    </motion.div>
  );
};

export default ProductsCarousell;